__turbopack_context__.v({
  "drawerContent": "SideMenu-module-scss-module__gcRCvq__drawerContent",
  "link": "SideMenu-module-scss-module__gcRCvq__link",
});
